import { call, fork, put, take } from 'redux-saga/effects';
import {RestartDepotPayload, restartDepot} from '../action/depotsCommands';
import {Action} from 'redux-actions';
import {enqueueErrorSnackbar, enqueueSuccessSnackbar} from '../action/snackbarCommands';
import {getI18n} from 'react-i18next';
import {Api} from '../api';
import Logger from '../common/logger';

export const onRestartDepot = function*(depotId: string) {
    try {
        yield call(Api.restartDepot, depotId);

        yield put(enqueueSuccessSnackbar({
            message: getI18n().t('snackbar.success.restart_depot', { depotId }),
        }));
    } catch (e) {
        Logger('Saga').error(e);
        yield put(enqueueErrorSnackbar({
            message: getI18n().t('snackbar.error.restart_depot', { depotId }),
        }));
    }
};

export function* restartDepotFlow() {
    while (true) {
        const action: Action<RestartDepotPayload> = yield take(restartDepot.toString());
        yield fork(onRestartDepot, action.payload.depotId);
    }
}
